import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import Seo from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import ProductCard from "@/components/site/ProductCard";

export default function Category() {
  const { slug } = useParams();
  const [products, setProducts] = useState([]);
  const [category, setCategory] = useState(null);

  useEffect(() => {
    api.get("/products", { params: { category: slug } }).then((r) => setProducts(r.data)).catch(() => {});
    api.get("/categories").then((r) => setCategory(r.data.find((c) => c.slug === slug))).catch(() => {});
  }, [slug]);

  return (
    <div className="pt-28 pb-28">
      <Seo
        title={category?.name || "Collection"}
        description={category?.tagline || "Explore the Equine Evolve collection."}
        image={category?.image}
      />
      <div className="relative h-[44vh] overflow-hidden ee-grain mb-16">
        {category?.image && <img src={category.image} alt={category.name} className="absolute inset-0 h-full w-full object-cover" />}
        <div className="absolute inset-0 bg-gradient-to-t from-[#0C0A09] via-black/50 to-black/40" />
        <div className="relative h-full flex flex-col items-center justify-center text-center px-6">
          <Reveal>
            <p className="ee-overline mb-4">Collection</p>
            <h1 className="font-display text-5xl md:text-7xl tracking-tight">{category?.name || slug}</h1>
            {category?.tagline && <p className="text-[#A8A29E] mt-5 max-w-xl">{category.tagline}</p>}
          </Reveal>
        </div>
      </div>

      <div className="px-6 md:px-12 lg:px-24 max-w-[1600px] mx-auto">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="category-grid">
          {products.map((p, i) => (
            <Reveal key={p.id} delay={(i % 3) * 0.1}>
              <ProductCard product={p} index={i} />
            </Reveal>
          ))}
          {products.length === 0 && <p className="text-[#A8A29E]">No pieces in this collection yet.</p>}
        </div>
      </div>
    </div>
  );
}
